import { AddHotelForm } from '@/components/dashboard/AddHotelForm';

export default function HostAddHotel() {
  return <AddHotelForm />;
}
